export interface ICredential{
  id:number;
  username:string;
}
